export default __webpack_public_path__ + "static/media/hourglass-icon.c9738795.svg";